<template>
  <v-btn class="navbarButton middle file v-step-1" :disabled="!btnState">
    <v-icon>file_copy</v-icon>
    Import{{ disablingControl }}
    <input
      v-if="btnState"
      type="file"
      name="file"
      :disabled="!btnState"
      @change="upload($event)"
    />
  </v-btn>
</template>

<script>
import axios from 'axios';
// import router from "@/router"
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      spinnerShown: false,
      btn: 'btn',
    };
  },
  computed: {
    ...mapGetters({
      btnState: 'btnImportValue',
    }),
    disablingControl() {
      return this.disableBtn();
    },
  },
  methods: {
    disableBtn() {
      if (this.btnState === false) {
        this.btn = 'btn-disabled';
      }
    },
    optimisation() {
      var self = this;
      const user = this.$store.state.userInfos.email;
      const url =
        process.env.VUE_APP_BASE_URL + process.env.VUE_APP_OPTIMISATION;
      axios({
        method: 'get',
        url: url,
        headers: {
          user: user,
        },
      })
        .then(response => {
          self.$store.dispatch('addOptimId', response.data);
        })
        .catch(() => {
          self.$store.dispatch('removeOptimId');
        });
    },
    upload(event) {
      if (this.btnState === true) {
        this.$store.commit('setImporting', true);
        const url =
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_UPLOAD_FILE;
        const file = event.target.files[0];
        var data = new FormData();
        data.append('file', file);
        let user = this.$store.state.userInfos.email;
        let self = this;
        let httpContinueStatus = false;
        self.btn = 'btn-disabled';
        self.$store.commit('setAllButtonsHidden');
        axios({
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'multipart/form-data',
            user: user,
          },
          data: data,
        })
          .then(response => {
            if (response.status === 200) {
              self.optimisation();
              self.btn = 'btn';
              this.$toasted.show(
                "Votre fichier a été traité et un mail récapitulatif de l'import vous a été envoyé.",
                { type: 'success' }
              );
            } else if (response.status === 204) {
              self.btn = 'btn';
              this.$toasted.show(
                "Votre fichier n'a pas pu être traité à cause d'erreurs, veuillez vous référer à l'email reçu pour en savoir plus.",
                { type: 'error' }
              );
            } else if (response.status === 226) {
              httpContinueStatus = true;
            }
          })
          .catch(error => {
            self.$store.dispatch('showDownloadBtn');
            self.$emit('hideSpinner');
            self.btn = 'btn';
            if (error.response.status === 423) {
              var date = new Date(error.response.data);
              this.$toasted.show(
                "Une maintenance est en cours. L'import de fichier est temporairement désactivé. La fin de la maintenance est prévue le : " +
                  date.toLocaleString('fr-FR'),
                { type: 'info' }
              );
            } else {
              this.$toasted.show(
                "Votre fichier n'a pas pu être traité, veuillez vous référer à l'email reçu pour en savoir plus.",
                { type: 'error' }
              );
            }
          })
          .finally(() => {
            if (httpContinueStatus === false) {
              this.$store.dispatch('fetchUserInfos').then(() => {
                const userInfos = this.$store.state.userInfos;
                let path = null;

                if (userInfos.pageAccueil === true) {
                  path = '/accueil';
                } else if (userInfos.pageAvant === true) {
                  path = '/vision-globale';
                } else if (userInfos.pageApres === true) {
                  path = '/optimisation';
                } else {
                  path = '/accueil';
                }
                this.$router.push({ path: path });
              });
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.file {
  position: relative;
  overflow: hidden;
}
input {
  position: absolute;
  font-size: 3.125rem;
  opacity: 0;
  right: 0;
  top: 0;
  cursor: pointer;
}
.btn {
  background-color: #39bfbd;
}
i.material-icons {
  line-height: 2.18rem;
}
input[type='file']:disabled {
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.12156862745098039) !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #a36a13 !important;
  cursor: default;
}
.btn-disabled {
  background-color: rgba(0, 0, 0, 0.12156862745098039) !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #a36a13 !important;
  cursor: default;
  text-decoration: none;
  text-align: center;
  letter-spacing: 0.5px;
  border: none;
  border-radius: 2px;
  height: 36px;
  line-height: 36px;
  padding: 0 16px;
  text-transform: uppercase;
  font-size: 14px;
}
</style>
